<div class="wallet-selector-footnote">
  <a
    href="https://apps.apple.com/us/app/webauth-com/id1594500069"
    id="iOS"
    target="_blank"
    rel="noreferrer"
  >
    <img
      alt="Download on the App Store"
      src="https://xprnetwork.org/static/719169dd7ea5089ae32be4dcae845078/DownloadApple.svg"
    />
  </a>
  <a
    href="https://play.google.com/store/apps/details?id=com.metallicus.webauth"
    id="Android"
    target="_blank"
    rel="noreferrer"
  >
    <img
      alt="Get it on Google Play"
      src="https://xprnetwork.org/static/b36e63520d1db11b0ce4989b73866ae0/DownloadGoogleEN.svg"
    />
  </a>
</div>

<style lang="scss" global>
  .wallet-selector-footnote {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    position: relative;
    font-family: 'Circular Std Book', sans-serif;
    font-size: 16px;
    text-align: center;
    color: white !important;

    height: 50px;
    width: 360px;

    a {
      color: #ffffff !important;
      width: 170px;
    }
  }
</style>
